module.exports = __webpack_public_path__ + "static/2021SNGLiveMainHeader2-3160fe917f35e69eb79876497fcddb9f.png";